import React from 'react';
import { Box, Typography } from '@mui/material';

interface ConfirmHeaderProps {
  title: string;
  subtitle: string;
  iconColor?: string;
}

const ConfirmHeader: React.FC<ConfirmHeaderProps> = ({
  title,
  subtitle,
  iconColor,
}) => {
  const formatSubtitle = (text: string) => {
    const sentences = text.split('? ');
    if (sentences.length > 1) {
      return (
        <>
          <Typography
            fontFamily="Outfit"
            fontWeight="600"
            fontSize="16px"
            color="var(--primary-navy)"
            mb={1}
          >
            {sentences[0]}?
          </Typography>
          <Typography
            fontFamily="Outfit"
            fontWeight="400"
            fontSize="14px"
            color="#75838A"
          >
            {sentences[1]}
          </Typography>
        </>
      );
    }
    return (
      <Typography
        fontFamily="Outfit"
        fontWeight="600"
        fontSize="16px"
        color="var(--primary-navy)"
        mb={1}
      >
        {text}
      </Typography>
    );
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Box
          component="i"
          className="bx bx-error-circle"
          sx={{
            fontSize: '24px',
            color: iconColor,
            mr: 1.5,
          }}
        />
        <Typography
          fontFamily="Lufga"
          fontWeight="500"
          fontSize="24px"
          color="var(--primary-navy)"
        >
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          borderBottom: '1px solid #E5E7EB',
          mb: 3,
          width: '100%',
        }}
      />

      {formatSubtitle(subtitle)}
    </Box>
  );
};

export default ConfirmHeader;
